<template>
  <div class="flex-disp">
    <UserEditModal :active="editModal" :user="item_to_edit" @toggle="editModalToggle(false)" />
      <!--
    <confirmation-dialog :active="confirmationModalShow">
      <template v-slot:header> ¿Desea eliminar el usuario? </template>
      <template v-slot:content>
        Los cambios no podran ser revertidos.
      </template>
      <template v-slot:actions>
        <v-btn
          class="v-btn--red"
          @click="
            () => {
              deleteUser(item_to_delete.id);
              confirmationModalToggle(false);
              item_to_delete = null;
            }
          "
        >
          Eliminar
        </v-btn>
        <v-btn
          class="v-btn--secondary"
          @click="
            () => {
              confirmationModalToggle(false);
            }
          "
        >
          Cancelar
        </v-btn>
      </template>
    </confirmation-dialog>
    -->
    <div class="btns-cont">
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="itemsPerPage"
        :page.sync="page"
        @page-count="pageCount = $event"
        hide-default-footer
        class="table"
      >
        <template #item.actions="item">
          <div class="d-flex justify-end">
            <v-btn
              class="btn-icon--primary btn-icon"
              @click="() => {
                item_to_edit = item.item
                editModalToggle(true)
              }"
              ><v-icon>mdi-pencil</v-icon></v-btn
            >
            <v-btn
              class="btn-icon--delete btn-icon ml-3"
              @click="
                () => {
                  item_to_delete = item.item;
                  confirmationModalToggle(true);
                }
              "
              ><v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          class="pagination"
          :length="pageCount"
          v-model="page"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
//import ConfirmationDialog from "../Dialogs/ConfirmationDialog.vue";
import UserEditModal from "../Users/UserEditModal.vue";
import { mapActions, mapMutations } from "vuex";

export default {
  components: { UserEditModal },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      confirmationModalShow: false,
      editModal: false,
      item_to_edit: {
        name: "",
        email: ""
      },
      item_to_delete: null,
      headers: [
        {
          align: "center",
          sortable: true,
          text: "nombre",
          value: "name",
        },
        {
          align: "center",
          sortable: true,
          text: "correo",
          value: "email",
        },
        {
          align: "center",
          sortable: false,
          text: "",
          value: "actions",
        },
      ],
    };
  },
  props: {
    users: {
      type: Array,
      default: []
    },
  },
  methods: {
    ...mapActions ({
      delete: 'users/deleteUser',
    }),
    confirmationModalToggle(value) {
      this.confirmationModalShow = value;
    },
    editModalToggle(value) {
      this.editModal = value;
    },
    deleteUser(id) {
      this.delete(id);
    },
  },
};
</script>
